// extracted by mini-css-extract-plugin
export default {"card":"XZ-z","carouselContainer":"YZ-z","carouselContent":"ZZ-z"};